const tableHeader = [
  'Cliente',
  'Endereço',
  'CNPJ/CPF',
  'Estado',
  'Telefone',
  'WhatsApp',
  'Vendedor',
  'Editar',
  'Excluir',
];

const Tablecadastro = [
  { id: 'nome', title: 'Nome', type: 'text', placeholder: '...' },
  { id: 'email', title: 'email', type: 'text', placeholder: ' ...' },
  { id: 'cpfCNPJ', title: 'cpfCNPJ', type: 'text', placeholder: ' ...' },
  { id: 'endereco', title: 'endereco', type: 'text', placeholder: ' ...' },
  { id: 'telefone', title: 'telefone', type: 'text', placeholder: ' ...' },
  { id: 'whatsapp', title: 'whatsapp', type: 'text', placeholder: ' ...' },
  { id: 'documento', title: 'documento', type: 'text', placeholder: ' ...' },
  { id: 'tipoDocumento', title: 'Tipo Documento', type: 'text', placeholder: ' ...' },
  { id: 'razaoSocial', title: 'Razao Social', type: 'text', placeholder: ' ...' },
  { id: 'nomeFantasia', title: 'Nome Fantasia', type: 'text', placeholder: ' ...' },
  { id: 'estado', title: 'Estado', type: 'text', placeholder: ' ...' },
  { id: 'vendedor', title: 'Vendedor', type: 'select', placeholder: ' ...' },
];

const title = 'Cadastro de Cliente';

export const cadastro = {
  title: title,
  cadastro: Tablecadastro,
};

export const table = {
  header: tableHeader,
  type: 'cliente',
};
